import React from 'react';

export const ReportsIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="27.9591" cy="27.8926" r="25.5" stroke="#8092A0" strokeWidth="4" />
    <line x1="29.9591" y1="7.8501" x2="29.9591" y2="47.9353" stroke="#8092A0" strokeWidth="4" />
  </svg>
);
